<template>
  <div class="timeline-item active js-timeline-step active" ref="currentStep">
    <div class="item-badge">{{ store.previousSteps.length + 1 }}</div>
    <div class="item-content">
      <h2>{{ store.currentStep.caption }}</h2>
      <div class="btn-group btn-group-vertical radio-group" data-toggle="buttons">
        <div v-for="subItem in store.currentStep.subItems" :key="subItem.id" class="radio-button btn">
          <input
            @click.prevent="goToStep(subItem)"
            :id="`radio-${subItem.id}`"
            :name="`radio-${store.currentStep.id}`"
            type="radio"
            class="radio-button__input" />
          <label
            @click.prevent="goToStep(subItem)"
            :for="`radio-${subItem.id}`"
            class="radio-button__label radio-text">
            {{ subItem.caption }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useWizardStepsStore } from "../store/wizardStepsStore";
import { ref } from "vue";

const store = useWizardStepsStore();
const currentStep = ref<HTMLDivElement>();

const goToStep = (option: Step) => {
  store.previousSteps.push({ ...store.currentStep, chosenValue: option.id });

  const nextStep = store.currentStep.subItems.find((subItem) => {
    return subItem.id === option.id
  }) as Step;

  store.currentStep = nextStep.subItems[0];

  window.scroll({
    top: currentStep.value!.offsetTop - 40,
    behavior: 'smooth'
  });
}
</script>